// src/client/types/settings.ts
// ===== SETTINGS TYPES =====

export interface Setting {
  id: number;
  key: string;
  value: string;
  type: SettingType;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface NewSettingForm {
  key: string;
  value: string;
  type: 'string' | 'boolean' | 'number' | 'json';
}

export type SettingType = 'string' | 'boolean' | 'number' | 'json';

// ===== SELECTORS TYPES =====

export interface Selector {
  id: number;
  name: string;
  category: string;
  selector: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SelectorFormData {
  name: string;
  category: string;
  selector: string;
  description: string;
  isActive: boolean;
}

// ===== SCORE RANGES TYPES =====

export interface ScoreRange {
  id: string;
  label: string;
  minValue: number;
  maxValue: number;
  color: string;
  order: number;
}

export interface InsertScoreRange {
  label: string;
  minValue: number;
  maxValue: number;
  color: string;
  order: number;
}

// ===== CATEGORY TYPES (re-export from shared) =====
// These come from @shared/types but we re-export for convenience

export type { ProfileCategory } from '@shared/types';

// ===== VALIDATION HELPERS =====

export function validateSettingKey(key: string): string | null {
  if (!key.trim()) return 'Setting key ist erforderlich';
  if (!/^[a-z0-9.]+$/i.test(key)) return 'Setting key darf nur Buchstaben, Zahlen und Punkte enthalten';
  return null;
}

export function validateSettingValue(value: string, type: SettingType): string | null {
  if (!value && value !== '0' && value !== 'false') return 'Setting value ist erforderlich';
  
  if (type === 'number' && isNaN(Number(value))) {
    return 'Wert muss eine Zahl sein';
  }
  
  if (type === 'json') {
    try {
      JSON.parse(value);
    } catch {
      return 'Ungültiges JSON-Format';
    }
  }
  
  return null;
}

export function validateSelectorForm(data: SelectorFormData): string | null {
  if (!data.name.trim()) return 'Name ist erforderlich';
  if (!data.category.trim()) return 'Feature-Modul ist erforderlich';
  if (!data.selector.trim()) return 'CSS Selector ist erforderlich';
  return null;
}

export function detectSettingType(value: string): SettingType {
  if (value === 'true' || value === 'false') return 'boolean';
  if (!isNaN(Number(value)) && value !== '') return 'number';
  try {
    JSON.parse(value);
    if (value.startsWith('{') || value.startsWith('[')) return 'json';
  } catch {}
  return 'string';
}